import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginUser as apiLogin } from '../api/auth';
import {
  storeToken, storeRefreshToken, storeUser,
  getUser, getToken, getRefreshToken, clearAll
} from '../utils/localStorage';
import queryClient from '../lib/queryClient';

// Removed: import { getDefaultRouteByRole } from '../utils/roleRoute'; // This was unused here

// Thunk: login
export const loginThunk = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const data = await apiLogin(credentials); // uses axios via auth.js
    if (!data || data.status !== 'success') return rejectWithValue(data?.message || 'Login failed');

    const { access_token, refresh_token, user } = data;
    if (access_token) storeToken(access_token);
    if (refresh_token) storeRefreshToken(refresh_token);
    if (user) storeUser(user);

    return { user, access_token, refresh_token };
  } catch (err) {
    return rejectWithValue(err.message || 'Login error');
  }
});

// Slice
const initialState = {
  user: getUser(),
  access_token: getToken(),
  refresh_token: getRefreshToken(),
  status: 'idle',
  error: null,
  isAuthenticated: !!getToken(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // manual set (used by axiosClient after refresh)
    setCredentials(state, action) {
      const { user, access_token, refresh_token } = action.payload;
      state.user = user || state.user;
      state.access_token = access_token || state.access_token;
      state.refresh_token = refresh_token || state.refresh_token;
      state.isAuthenticated = true;
    },
    logoutLocal(state) {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.isAuthenticated = false;

  // 🔥 CRITICAL: Clear React Query cache
  queryClient.clear();

  // Clear local storage
      clearAll && clearAll();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(loginThunk.fulfilled, (s, action) => {
        s.status = 'succeeded';
        s.user = action.payload.user;
        s.access_token = action.payload.access_token;
        s.refresh_token = action.payload.refresh_token;
        s.isAuthenticated = true;
      })
      .addCase(loginThunk.rejected, (s, action) => {
        s.status = 'failed';
        s.error = action.payload || action.error.message;
      });
  }
});

export const { setCredentials, logoutLocal } = authSlice.actions;
export default authSlice.reducer;